import { Box, Button, Card, CardMedia, Grid, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

import { useTheme } from "@emotion/react";

import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useSnackbarContext } from "../../component/SnackbarContext";
import SweepStakeTypography from "../../component/SweepStakeTypography";
import { endPoints } from "../../constant/Environment";
import CoinBackImg from "../../images/coin-back.svg";
import CoinBigImg from "../../images/coin-big.svg";
import CoinSmallImg from "../../images/coin-small.svg";
import coinimg1 from "../../images/mainpackage.png";
import svg from "../../images/newSvg.svg";
import coinimg2 from "../../images/secondpackage.png";
import { setLoginData } from "../../redux/Reducers/AuthReducer/authSplice";
import { setLoading } from "../../redux/Reducers/GlobalReducer/globalSlice";
import { getAllData } from "../../Utility/API";
import DailyReward from "../DailyReward";
import RedeemSCCode from "../RedeemSCCode";
import CopiedButton from "./CopiedButton";
import MailFeature from "./MailFeature";
import PaymentButton from "./PaymentButton";
import PaymentModal from "./PaymentModal";
import SharePost from "./SharePost";
import ShareTimerText from "./ShareTimerText";
import TimerButton from "./TimerButton";
import WheelOfFortune from "./WheelofFortune";
import BirthDayFeature from "./BirthDayFeature";
import ReferFriendInfoModal from "./ReferFriendInfoModal";
import EmailPackage from "./EamilPacakage";
import { getCasinoPackagesWithConvertedPrice } from "../../Utility/packagePricing";
import { formatCurrencyAmount } from "../../Utility/currencyDisplay";
import { useQuickDeposit } from "../../component/QuickDeposit";


const BuyCoinsNew = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { t } = useTranslation();
  const { openQuickDeposit } = useQuickDeposit();

  const dispatch = useDispatch();

  const authState = useSelector((state) => state.auth);
  const { isAuthenticated, IsLoginData } = authState;
  // console.log("isAuthenticated", IsLoginData);
  const { showSuccessSnackbar, showErrorSnackbar } = useSnackbarContext();
  const [selecteNewPackage, setSelectdNewPackage] = useState({});
  const {
    dailyLoginClaim,
    nextDailyLogin,
    validation,
    verification,
    packagecount,
    nextPost,
    postClaim,
    nextMail,
    mailClaim,

    birthDayClaim,
    nextBirthDay,
    lastBirthDay,
    showBirthDayClaim,
  } = IsLoginData || {};

  // console.log('loginData',loginData)

  const [mainItems, setMainItems] = useState([]);

  const [referAndReward, setReferAndReward] = useState([]);
  const [selectedRefer, setSelectedRefer] = useState({});
  const [payModal, setPayModal] = useState(false);
  const [paymentMode, setPaymentMode] = useState([]);
  const [segments, setSegments] = useState([]);
  const [probabilities, setProbabilities] = useState([]);
  const [colors, setColors] = useState([]);
  const [wofdata, setWofData] = useState([]);

  const [mailModal, setMailModal] = useState(false);
  const [disabledMail, setDisabledMail] = useState(false);

  const [birthdayModal, setBirthDayModal] = useState(false);
  const [disabledBirthDay, setDisabledBirthDay] = useState(false);

  // console.log('mailClaim',mailClaim,'disabledMail',disabledMail)

  const [codeModal, setCodeModal] = useState(false); // cliam sc coin modal

  const getCoinPackageList = async (list) => {
    dispatch(setLoading(true));
    await getCasinoPackagesWithConvertedPrice()
      .then((response) => {
        dispatch(setLoading(false));
        if (response?.status === "success" && response?.data?.length > 0) {
          const excludePackageIds = response?.data[0]?.exclude_package || [];

          const filteredPackages = response?.data?.filter(
            (item) => !excludePackageIds.includes(item?.id),
          );

          setMainItems(filteredPackages);
        }
      })
      .catch((error) => {
        dispatch(setLoading(false));
        console.error(error);
      });
  };

  const getConfigurationList = async (list) => {
    let url = `${endPoints.api.GET_CONFIGURATION}`;
    dispatch(setLoading(true));
    await getAllData(url)
      .then((response) => {
        dispatch(setLoading(false));
        if (response?.status === "success" && response?.data?.length > 0) {
          const filteredData = response?.data?.filter((item) => item.isActive);

          setReferAndReward(filteredData);
        }
      })
      .catch((error) => {
        dispatch(setLoading(false));
        console.error(error);
      });
  };

  const handleOpenPaymentModal = (data) => {
    // Package tiles keep the normal flow: pick the coin inside PaymentModal.
    setSelectdNewPackage(data);
    setPayModal(true);
  };

  const GetUserById = async () => {
    if (IsLoginData?.idUser) {
      try {
        const url = `${endPoints.api.GET_BY_USERID}/${IsLoginData?.idUser}`;
        const response = await getAllData(url);
        dispatch(setLoginData({ user: response?.data, isAuthenticated: true }));
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    getCoinPackageList();
    GetUserById();
    getConfigurationList();
  }, []);

  useEffect(() => {
    // Check if packageId is in URL parameters (for email packages)
    const packageId = searchParams.get("packageId");
    if (packageId) {
      setEmailPackageOpen(true);
    }
  }, [searchParams]);

  useEffect(() => {
    // A promo boost links straight to its package. It uses its own parameter
    // because ?packageId belongs to the email-campaign modal, which looks the
    // package up by a different column and would report it as unavailable.
    const promoPackageId = searchParams.get("promoPackageId");
    if (!promoPackageId) {
      return;
    }

    // The promo modal passes the package it already loaded. Looking it up by id
    // covers a link opened directly; it is not read out of mainItems because that
    // list leaves out email-only, daily-streak and player-excluded packages, and a
    // promo can point at any of them.
    const openPromoPackage = async () => {
      const pkg =
        location.state?.promoPackage ||
        (await getAllData(`${endPoints.api.GET_PACKAGE_BY_ID}/${promoPackageId}`));
      if (pkg?.id) {
        handleOpenPaymentModal(pkg);
      } else {
        showErrorSnackbar(t("buyCoinsModals.emailPackageNoPackageFound"));
      }
      // Drop the parameter once it has been handled. This page stays mounted when a
      // promo is redeemed from it, so leaving it set would make the next redeem look
      // like no change at all and nothing would open until a reload.
      navigate("/buy-coins", { replace: true });
    };
    openPromoPackage();
  }, [searchParams, location.state]);

  const payModalClose = () => {
    setPayModal(false);
    // Closed the buy modal without completing a payment (a completed payment
    // clears popup_shop_visits and navigates away before this matters).
    try {
      window.dispatchEvent(new CustomEvent("popup:trigger", { detail: { trigger: "package_hesitation" } }));
    } catch (e) { /* never break the buy flow over a popup trigger */ }
  };

  const fetchPaymentMethods = async () => {
    try {
      let url = `${endPoints.api.GET_PAYMENTS}`;
      const response = await getAllData(url);
      if (response?.status === "success") {
        setPaymentMode(response?.data);
      } else {
        showErrorSnackbar(response?.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchPaymentMethods();
  }, []);

  const [openDailyRewards, setOpenDailyRewards] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [openWheel, setOpenWheel] = useState(false);
  const [emailPackageOpen, setEmailPackageOpen] = useState(false);

  const handleOpenWheel = async () => {
    try {
      let url = `${endPoints.api.GET_SPIN_VALUES}/${IsLoginData?.idUser}`;
      const response = await getAllData(url);
      if (
        response?.status === "success" &&
        response?.data?.segments?.length &&
        response?.data?.probabilities?.length &&
        response?.data?.colors.length
      ) {
        setSegments(response?.data?.segments);
        setProbabilities(response?.data?.probabilities);
        setColors(response?.data?.colors || []);
        setWofData(response?.data);
        setOpenWheel(true); // Opening wheel only when data is coming
      } else {
        showErrorSnackbar(t("buyCoinsPage.somethingWentWrong"));
      }
    } catch (err) {
      console.error(err);
      showErrorSnackbar(t("buyCoinsPage.somethingWentWrong"));
    }
  };

  const handleCloseWheel = () => {
    setOpenWheel(false);
  };

  const openShareModal = (item) => {
    setSelectedRefer(item);
    setShareModal(true);
  };

  const closeRewardModal = (flag) => {
    if (flag) {
      GetUserById();
      setOpenDailyRewards(false);
    } else {
      setOpenDailyRewards(false);
    }
  };

  const calculateBoostCoin = (purchasePrice, percentage) => {
    // Extract numeric value from formatted currency string (e.g., "£ 8.93" -> 8.93)
    const numericPrice = typeof purchasePrice === 'string' 
      ? parseFloat(purchasePrice.replace(/[^0-9.-]+/g, '')) 
      : purchasePrice;
    
    if (isNaN(numericPrice) || !percentage) return "";
    
    const coinpct = (Math.round(numericPrice) * percentage) / 100;
    return coinpct ? coinpct.toFixed(2) : "";
  };



  return (
    <>
      {/* <Helmet>
        <title>{t("buyCoinsPage.pageTitle")}</title>
        <meta
          name="description"
          content={t("buyCoinsPage.pageDescription")}
        />
      </Helmet> */}
      <Helmet>
        <title>{t("buyCoins.pageTitle")}</title>
        <meta name="description" content={t("buyCoins.metaDescription")} />
        <link rel="canonical" href="https://coin.spinsagacasino.com/buy-coins/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="SpinSaga Casino" />
        <meta property="og:url" content="https://coin.spinsagacasino.com/buy-coins/" />
        <meta property="og:title" content={t("buyCoins.pageTitle")} />
        <meta property="og:description" content={t("buyCoins.metaDescription")} />
        <meta property="og:image" content="https://coin.spinsagacasino.com/512x512.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t("buyCoins.pageTitle")} />
        <meta name="twitter:description" content={t("buyCoins.metaDescription")} />
        <meta name="twitter:image" content="https://coin.spinsagacasino.com/512x512.png" />
      </Helmet>

      <main className="inner-body inner_space">
        {/* Quick deposit entry point — hidden while the flow is being tested
            from the QA-only button in the sidebar. Restore once it goes live.
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
          <Button
            size="small"
            onClick={openQuickDeposit}
            sx={{
              background: theme.palette.custom.pink_bg,
              color: theme.palette.custom.white_gray,
              borderRadius: 2,
              px: 2.5,
              py: 1,
              fontWeight: 700,
              textTransform: "none",
            }}
          >
            {t("buyCoinsPage.quickDeposit", "Quick Deposit")}
          </Button>
        </Box>
        */}

        {codeModal && (
          <RedeemSCCode
            openCodeModal={codeModal}
            closeCodeModal={() => {
              setCodeModal(false);
            }}
          />
        )}
        <PaymentModal
          open={payModal}
          onClose={payModalClose}
          selecteNewPackage={selecteNewPackage}
          GetUserById={GetUserById}
          getCoinPackageList={getCoinPackageList}
          paymentMode={paymentMode}
        />
        {openDailyRewards && (
          <DailyReward
            openDailyRewards={openDailyRewards}
            closeRewardModal={closeRewardModal}
            selectedRefer={selectedRefer}
          />
        )}
        {shareModal && (
          <SharePost
            openDailyRewards={shareModal}
            closeRewardModal={() => {
              setShareModal(false);
            }}
            selectedPost={selectedRefer}
          />
        )}

        {mailModal && (
          <MailFeature
            openMailModal={mailModal}
            closeMailModal={() => {
              setMailModal(false);
            }}
            selectedPost={selectedRefer}
            buttonDisabled={() => {
              setDisabledMail(true);
            }}
          />
        )}
        {birthdayModal && (
          <BirthDayFeature
            openMailModal={birthdayModal}
            closeMailModal={() => {
              setBirthDayModal(false);
            }}
            selectedPost={selectedRefer}
            buttonDisabled={() => {
              setDisabledBirthDay(true);
            }}
          />
        )}

        {/* wheel of fortune code  */}

        <WheelOfFortune
          open={openWheel}
          handleClose={handleCloseWheel}
          wofdata={wofdata}
        />

        {/* end of wheel of fortune code  */}

        {/* first section hide right now */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: isAuthenticated ? "0px" : "60px",
          }}
        >
          <div className="icon_heading">
            <Typography sx={{ color: theme.palette.custom.white_gray }}>
              <span
                style={{
                  marginRight: "10px",
                }}
              >
                <img src={coinimg1} />
              </span>
              {t("promotions.specialOffers")}
            </Typography>
          </div>

          {/* <div>
            <Button
              className="full_btn"
              size="small"
              sx={{
                background: theme.palette.custom.pink_bg,
                color: theme.palette.custom.white_gray,
              }}
              onClick={() => {
                isAuthenticated ? setCodeModal(true) : navigate("/login");
              }}
            >
              Claim SC
            </Button>
          </div> */}
        </div>

        <Grid className="buy_row" container spacing={{ xs: 5, sm: 4, md: 2 }}>
          <div className="button_scroll">
            <div className="c_scroll ">
              <div className="custom_row">
                {mainItems?.map((item, index) => {
                  if (item?.isSpecial == 1) {
                    return (
                      <main className="custom_col" key={item?.id}>
                        <Card
                          className="c_card middle_card"
                          sx={{
                            background: theme.palette.custom.lgray,
                            borderColor: theme.palette.custom.redblue_border,
                          }}
                        >
                          <div className="card_label">
                            <p>
                              {/* <span
                                style={{ fontSize: "10px", color: "white" }}
                              >
                                {t("buyCoinsPage.freeSC")}
                              </span> */}
                              <span style={{ color: "white" }}>
                                {" "}
                                +{item?.bonus_amount}
                              </span>
                            </p>
                            <img src={svg} alt="icon" />
                          </div>

                          <div className="buy_card1">
                            <div className="right_half">
                              <CardMedia
                                component="img"
                                height="100%"
                              image={`${endPoints?.imageCDN}${item?.creative}`}
                              />
                            </div>
                            <div className="left_half">
                              {/* The button already shows the price, so name the
                                  package here instead of repeating it. */}
                              <Typography
                                className="f18 f-bold"
                                sx={{ color: theme.palette.custom.white_gray }}
                              >
                                {item?.package_name}
                              </Typography>

                              <PaymentButton
                                item={item}
                                GetUserById={GetUserById}
                                getCoinPackageList={getCoinPackageList}
                                className="best_btn"
                                allowOnPress={true}
                                handleOnPress={handleOpenPaymentModal}
                              />
                            </div>
                          </div>
                        </Card>
                      </main>
                    );
                  } else {
                    return null;
                  }
                })}

               
              </div>
            </div>
          </div>
        </Grid>

        <div className="icon_heading">
          <Typography sx={{ color: theme.palette.custom.white_gray }}>
            <span
              style={{
                marginRight: "10px",
              }}
            >
              <img src={coinimg1} />
            </span>{" "}
            {t("buyCoinsPage.mostPopularTitle")}
          </Typography>
        </div>
        <Grid className="buy_row" container spacing={{ xs: 2, sm: 4, md: 4 }}>
          {mainItems?.map((item, index) => {
            if (item?.isPopular == 1 && item?.isSpecial == 0) {
              return (
                <>
                  <Grid item xs={4} md={6}>
                    <Card
                      className="c_card long-card"
                      sx={{
                        background: theme.palette.custom.gray3,
                        borderColor: theme.palette.custom.btn_border,
                      }}
                    >
                      <div className="long_img_coin">
                        <img
                          class="big_coin"
                          src={CoinBigImg}
                          alt="Coin icon"
                        />
                        <img
                          class="small_coin"
                          src={CoinSmallImg}
                          alt="Coin icon"
                        />
                        <img
                          class="back_coin"
                          src={CoinBackImg}
                          alt="Coin icon"
                        />
                      </div>
                      {item?.isFeature == 1 ? (
                        <div className="green_label">
                          <Box>
                            <Typography
                              sx={{
                                color: "white",
                              }}
                              variant="p"
                            >
                              {t("buyCoinsPage.featured")}
                            </Typography>
                          </Box>
                        </div>
                      ) : null}

                      <div className="half_flex">
                        <PaymentButton
                          item={item}
                          GetUserById={GetUserById}
                          getCoinPackageList={getCoinPackageList}
                          allowOnPress={true}
                          handleOnPress={handleOpenPaymentModal}
                        />

                        {item?.freeSpin && (
                          <Button
                            size="small"
                            sx={{
                              ml: 1,
                              borderRadius: "20px",
                              px: { xs: 1, md: 2 },
                              py: 0.5,
                              minWidth: { xs: 50, md: "auto" },
                              background: theme.palette.custom.red,
                              color: theme.palette.custom.white,
                              fontWeight: 700,
                              fontSize: { xs: "11px", md: "14px" },
                              boxShadow: "0 6px 14px rgba(0,0,0,0.18)",
                              border: "1px solid rgba(255,255,255,0.04)",
                              textTransform: "capitalize",
                              whiteSpace: "nowrap",
                              marginLeft: { xs: "-10px" },
                            }}
                          >
                            <Box
                              component="span"
                              sx={{ display: { xs: "none", md: "inline" } }}
                            >
                              +{item?.spinCount} {t("buyCoinsPage.freeSpins")}
                            </Box>
                            <Box
                              component="span"
                              sx={{
                                display: { xs: "inline", md: "none" },
                                fontSize: "11px",
                              }}
                            >
                              <>
                                +{item?.spinCount} {t("buyCoinsPage.freeSpin")}
                              </>
                            </Box>
                          </Button>
                        )}
                      </div>
                    </Card>
                  </Grid>
                  <Grid item xs={8} md={6}>
                    <Typography
                      sx={{ background: theme.palette.custom.dark_d }}
                      className="right_carddiv"
                    >
                      <Button
                        size="large"
                        sx={{
                          background: theme.palette.custom.greenhalf,
                          color: theme.palette.custom.green01,
                        }}
                      >
                         {`${item?.bonus_amount}`} {t("buyCoinsPage.bonus")} {" "}
                         {item?.isBoost ?
                        `+ ${calculateBoostCoin(item?.purchase_price, item?.boostValue)}
                        ⚡ ${t("buyCoinsPage.coinBoostAvailable")}` : ""}
                      </Button>

                      <Button
                        size="large"
                        sx={{
                          background: theme.palette.custom.greenhalf,
                          color: theme.palette.custom.green01,
                        }}
                      >
                        {item?.package_name}
                      </Button>
                    </Typography>
                  </Grid>

                  {/* <Grid item xs={4} md={3}>
                    <Typography
                      sx={{ background: theme.palette.custom.dark_d }}
                      className="right_carddiv"
                    >
                      <Button
                        size="small"
                        sx={{
                          background: theme.palette.custom.gray3,
                          color: theme.palette.custom.white,
                        }}
                      >
                        Daily{" "}
                        {item.max_claim_perday == 0
                          ? "N/A"
                          : item.max_claim_perday >= 100
                          ? "Unlimited"
                          : item.max_claim_perday == 1
                          ? `${item.max_claim_perday} `
                          : `${item.max_claim_perday} `}{" "}
                        Transfer for {`${item.days}`}{" "}
                        {item.days == 1 ? "day" : "days"}
                      </Button>
                    </Typography>
                  </Grid> */}
                </>
              );
            } else {
              return null;
            }
          })}
        </Grid>

        <div className="icon_heading">
          <Typography
            sx={{ color: theme.palette.custom.white_gray, marginTop: 5 }}
          >
            <span
              style={{
                marginRight: "10px",
              }}
            >
              <img src={coinimg2} />
            </span>{" "}
            {t("buyCoinsPage.moreCoinPackagesTitle")}
          </Typography>
        </div>

        <Grid className="buy_row" container spacing={{ xs: 2, sm: 4, md: 4 }}>
          {mainItems?.map((item, index) => {
            if (item?.isPopular == 1 || item?.isSpecial == 1) {
              return null;
            } else {
              return (
                <>
                  <Grid item xs={4} md={6}>
                    <Card
                      className="c_card long-card"
                      sx={{
                        background: theme.palette.custom.gray3,
                        borderColor: theme.palette.custom.btn_border,
                      }}
                    >
                      <div className="long_img_coin">
                        <img
                          class="big_coin"
                          src={CoinBigImg}
                          alt="Coin icon"
                        />
                        <img
                          class="small_coin"
                          src={CoinSmallImg}
                          alt="Coin icon"
                        />
                        <img
                          class="back_coin"
                          src={CoinBackImg}
                          alt="Coin icon"
                        />
                      </div>

                      <div className="half_flex">
                        <PaymentButton
                          item={item}
                          GetUserById={GetUserById}
                          getCoinPackageList={getCoinPackageList}
                          //to comment both below these lines for payment modal later for enable when muiplte payment are there (these are used 3 times)
                          allowOnPress={true}
                          handleOnPress={handleOpenPaymentModal}
                        />
                        {item?.freeSpin && (
                          <Button
                            size="small"
                            sx={{
                              ml: 1,
                              borderRadius: "20px",
                              px: { xs: 1, md: 2 },
                              py: 0.5,
                              minWidth: { xs: 50, md: "auto" },
                              background: theme.palette.custom.red,
                              color: theme.palette.custom.white,
                              fontWeight: 700,
                              fontSize: { xs: "11px", md: "14px" },
                              boxShadow: "0 6px 14px rgba(0,0,0,0.18)",
                              border: "1px solid rgba(255,255,255,0.04)",
                              textTransform: "capitalize",
                              whiteSpace: "nowrap",
                              marginLeft: { xs: "-10px" },
                            }}
                          >
                            <Box
                              component="span"
                              sx={{ display: { xs: "none", md: "inline" } }}
                            >
                              +{item?.spinCount} {t("buyCoinsPage.freeSpins")}
                            </Box>
                            <Box
                              component="span"
                              sx={{
                                display: { xs: "inline", md: "none" },
                                fontSize: "11px",
                              }}
                            >
                              <>
                                +{item?.spinCount} {t("buyCoinsPage.freeSpin")}
                              </>
                            </Box>
                          </Button>
                        )}
                      </div>
                    </Card>
                  </Grid>

                  <Grid item xs={8} md={6}>
                    <Typography
                      sx={{ background: theme.palette.custom.dark_d }}
                      className="right_carddiv"
                    >
                      <Button
                        size="large"
                        sx={{
                          background: theme.palette.custom.greenhalf,
                          color: theme.palette.custom.green01,
                        }}
                      >
                         {`${item?.bonus_amount}`} {t("buyCoinsPage.bonus")} {" "}
                         {item?.isBoost ?
                        `+ ${calculateBoostCoin(item?.purchase_price, item?.boostValue)}
                        ⚡ ${t("buyCoinsPage.coinBoostAvailable")}` : ""}  
                      </Button>

                      <Button
                        size="large"
                        sx={{
                          background: theme.palette.custom.greenhalf,
                          color: theme.palette.custom.green01,
                        }}
                      >
                        {item?.package_name}
                      </Button>
                    </Typography>
                  </Grid>

                  {/* <Grid item xs={4} md={3}>
                    <Typography
                      sx={{ background: theme.palette.custom.dark_d }}
                      className="right_carddiv"
                    >
                      <Button
                        size="small"
                        sx={{
                          background: theme.palette.custom.gray3,
                          color: theme.palette.custom.white,
                        }}
                      >
                        Daily{" "}
                        {item.max_claim_perday == 0
                          ? "N/A"
                          : item.max_claim_perday >= 100
                          ? "Unlimited"
                          : item.max_claim_perday == 1
                          ? `${item.max_claim_perday} `
                          : `${item.max_claim_perday} `}{" "}
                        Transfer for {`${item.days}`}{" "}
                        {item.days == 1 ? "day" : "days"}
                      </Button>
                    </Typography>
                  </Grid> */}
                </>
              );
            }
          })}
        </Grid>

        <Grid className="buy_footer" container>
          <Grid item container justifyContent="center" spacing={2}>
            <Grid item>
              <Button
                size="small"
                sx={{
                  background: theme.palette.custom.greenbtn,
                  color: theme.palette.custom.white,
                }}
                onClick={() => {
                  navigate("/contact-us");
                }}
              >
                <span style={{ textTransform: "capitalize" }}>
                  {t("buyCoinsPage.customerHelp")}
                </span>
              </Button>
            </Grid>

            <Grid item>
              <Button
                size="small"
                sx={{
                  background: theme.palette.custom.blue,
                  color: theme.palette.custom.white,
                }}
                onClick={() => {
                  navigate("/purchase-history");
                }}
              >
                <span style={{ textTransform: "capitalize" }}>
                  {t("buyCoinsPage.purchaseHistory")}
                </span>
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <SweepStakeTypography></SweepStakeTypography>
          </Grid>
        </Grid>
      </main>

      {/* Email Package Modal */}
      <EmailPackage
        open={emailPackageOpen}
        onClose={() => setEmailPackageOpen(false)}
      />
    </>
  );
};

export default BuyCoinsNew;
